import { SchedulerSettingsTabs } from '@lp/features/Scheduler/components';
import {
  SSchedulerSettingsInputsTab,
  SSchedulerSettingsRulesTab,
} from '@lp/features/Scheduler/SchedulerSurgeonsSettings/components';
import {
  useHtLuSSetScheduleSettingsInputsMutation,
  useHtLuSSetScheduleSettingsRulesMutation,
  useSHtLuScheduleRegionsQuery,
  useSHtLuScheduleSettingsInputsQuery,
  useSHtLuScheduleSettingsRulesQuery,
} from '@/queries/resource/schedule';

type SchedulerHtLuSurgeonsSettingsProps = {
  scheduleBackPath: string;
};

export const SchedulerHtLuSurgeonsSettings = ({ scheduleBackPath }: SchedulerHtLuSurgeonsSettingsProps) => {
  return (
    <SchedulerSettingsTabs
      inputsTab={
        <SSchedulerSettingsInputsTab
          scheduleBackPath={scheduleBackPath}
          useSScheduleRegionsQuery={useSHtLuScheduleRegionsQuery}
          useSScheduleSettingsInputsQuery={useSHtLuScheduleSettingsInputsQuery}
          useSSetScheduleSettingsInputsMutation={useHtLuSSetScheduleSettingsInputsMutation}
        />
      }
      rulesTab={
        <SSchedulerSettingsRulesTab
          scheduleBackPath={scheduleBackPath}
          useSScheduleSettingsRulesQuery={useSHtLuScheduleSettingsRulesQuery}
          useSSetScheduleSettingsRulesMutation={useHtLuSSetScheduleSettingsRulesMutation}
        />
      }
    />
  );
};
